<script lang="ts" setup>
import EventsMenu from '../components/events/EventsMenu.vue';
import EventsList from '../components/events/EventsList.vue';
import { useRoute } from 'vue-router';
import EventsSourcesList from '@/components/events/EventsSourcesList.vue';

const route = useRoute();
</script>

<template>
  <EventsMenu />
  <EventsList v-if="route.path === '/events'" />
  <EventsSourcesList v-if="route.path === '/events/sources'" />
</template>
